import { UserDirectoryDTO } from './user-directory-dto';
import { PageRowsResponseDTO } from './page-response-dto';

export interface UserDirectoryResponseDTO extends PageRowsResponseDTO<UserDirectoryDTO> {}
